import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getAdminSubscriptionsAPI = createAsyncThunk(
    "getAdminSubscriptionsAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAdminSubscriptions(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getAdminSubscriptionStatsAPI = createAsyncThunk(
    "getAdminSubscriptionStatsAPI",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getAdminSubscriptionStats());
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const grantFreeSubscriptionAPI = createAsyncThunk(
    "grantFreeSubscriptionAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.grantFreeSubscription(), payload);
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const searchUsersForSubscriptionAPI = createAsyncThunk(
    "searchUsersForSubscriptionAPI",
    async (search, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.searchUsersForSubscription(search));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    statsLoading: false,
    grantLoading: false,
    searchLoading: false,
    subscriptions: [],
    stats: null,
    searchUsers: [],
    pagination: {
        current_page: 1,
        total_pages: 1,
        total: 0,
        per_page: 10,
    }
}

const adminSubscriptionSlice = createSlice({
    initialState,
    name: "adminSubscriptionSlice",
    reducers: {
        clearSearchUsers: (state) => {
            state.searchUsers = [];
        }
    },
    extraReducers: (builder) => {
        // Get Subscriptions
        builder.addCase(getAdminSubscriptionsAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getAdminSubscriptionsAPI.fulfilled, (state, action) => {
            state.subscriptions = action.payload.data.data.data;
            state.pagination = {
                current_page: action.payload.data.data.current_page,
                total_pages: action.payload.data.data.last_page,
                total: action.payload.data.data.total,
                per_page: action.payload.data.data.per_page,
            };
            state.loading = false;
        });

        builder.addCase(getAdminSubscriptionsAPI.rejected, (state) => {
            state.loading = false;
        });

        // Get Stats
        builder.addCase(getAdminSubscriptionStatsAPI.pending, (state) => {
            state.statsLoading = true;
        });

        builder.addCase(getAdminSubscriptionStatsAPI.fulfilled, (state, action) => {
            state.stats = action.payload.data.data;
            state.statsLoading = false;
        });

        builder.addCase(getAdminSubscriptionStatsAPI.rejected, (state) => {
            state.statsLoading = false;
        });

        // Grant Free Subscription
        builder.addCase(grantFreeSubscriptionAPI.pending, (state) => {
            state.grantLoading = true;
        });

        builder.addCase(grantFreeSubscriptionAPI.fulfilled, (state) => {
            state.grantLoading = false;
        });

        builder.addCase(grantFreeSubscriptionAPI.rejected, (state) => {
            state.grantLoading = false;
        });

        // Search Users
        builder.addCase(searchUsersForSubscriptionAPI.pending, (state) => {
            state.searchLoading = true;
        });

        builder.addCase(searchUsersForSubscriptionAPI.fulfilled, (state, action) => {
            state.searchUsers = action.payload.data.data;
            state.searchLoading = false;
        });

        builder.addCase(searchUsersForSubscriptionAPI.rejected, (state) => {
            state.searchLoading = false;
        });
    }
});

export const { clearSearchUsers } = adminSubscriptionSlice.actions
export default adminSubscriptionSlice.reducer
